import { post, get, put, del } from "./api.service";

const TagService = {
    // Tags CRUD
    createTag(params) {
        return post("/tags", params);
    },

    getTag(id) {
        return get(`/tags/${id}`);
    },

    updateTag(id, params) {
        return put(`/tags/${id}`, params);
    },

    deleteTag(id) {
        return del(`/tags/${id}`, null);
    },

    searchTags(params) {
        return post("/tags/search", params);
    },

    // Tag Categories
    createTagCategory(params) {
        return post("/tags/categories", params);
    },

    deleteTagCategory(id) {
        return del(`/tags/categories/${id}`);
    },

    updateTagCategory(id, params) {
        return put(`/tags/categories/${id}`, params);
    },

    getTagsByCategory(id) {
        return get(`/tags/category/${id}`);
    },

    searchTagCategories(params) {
        return post("/tags/categories/search", params);
    },
};

export { TagService };
